import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom, type WritableAtom } from '@podium/store';
import type { AmplitudeExperiments } from '@schibsted-nmp/advertising-shared';

export const $amplitudeExperimentsAtom: WritableAtom<AmplitudeExperiments> =
  atom<AmplitudeExperiments>(
    AtomChannels.Podlet,
    AtomTopics.AmplitudeExperiments,
    {
      experiments: {},
      payloads: {}
    }
  );
